import { render } from "./CategoryRating.vue?vue&type=template&id=3ad7affc&scoped=true"
import script from "./CategoryRating.vue?vue&type=script&lang=js"
export * from "./CategoryRating.vue?vue&type=script&lang=js"

import "./CategoryRating.vue?vue&type=style&index=0&id=3ad7affc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad7affc"]])

export default __exports__